(function() {
    'use strict';
    
    // Helper to access halo functions
    function getHalo() {
        return window.halo || {};
    }
    
    const infiniteScrolling = {
        initInfiniteScrolling: function () {
            const paginationInfinite = document.querySelector('.pagination-infinite');
            if (!paginationInfinite) return;
            
            const handleScroll = () => {
                var currentScroll = window.pageYOffset || document.documentElement.scrollTop,
                    linkInfinite = paginationInfinite.querySelector('[data-infinite-scrolling]'),
                        position;

                if (linkInfinite && !linkInfinite.classList.contains('is-loading')) {
                    const rect = paginationInfinite.getBoundingClientRect();
                    position = rect.top + window.pageYOffset - 500;

                        if (currentScroll > position) {
                        var url = linkInfinite.getAttribute('href');
                        if (url) {
                            const halo = getHalo();
                            if (halo.doAjaxInfiniteScrollingGetContent) {
                                halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
                            }
                        }
                    }
            }
            };

            window.addEventListener('scroll', handleScroll);
            window.addEventListener('load', handleScroll);

            document.addEventListener('click', (event) => {
                const linkInfinite = event.target.closest('[data-infinite-scrolling]');
                if (linkInfinite) {
                    var url = linkInfinite.getAttribute('href');
                event.preventDefault();
                event.stopPropagation();
                const halo = getHalo();
                if (halo.doAjaxInfiniteScrollingGetContent) {
                    halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
                }
                }
            });
        },

        doAjaxInfiniteScrollingGetContent: function (url, link) {
            if (!link || !url) return;
            
            const loadingText = link.getAttribute('data-loading-more');
            const loadMoreText = link.getAttribute('data-load-more');
            
            if (loadingText) link.textContent = loadingText;
            link.classList.add('is-loading');
            
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(err => {
                            throw new Error(err.description || 'Erro ao carregar conteúdo');
                        });
                    }
                    return response.text();
                })
                .then(data => {
                    const halo = getHalo();
                    if (halo.ajaxInfiniteScrollingMapData) {
                        halo.ajaxInfiniteScrollingMapData(data);
                    }
                })
                .catch(error => {
                    alert(error.message || 'Erro ao carregar conteúdo');
                })
                .finally(() => {
                    if (loadMoreText) link.textContent = loadMoreText;
                    link.classList.remove('is-loading');
                    if (document.querySelector('.collection-masonry')) {
                        if (typeof resizeAllGridItems === 'function') {
                        resizeAllGridItems();
                    }
                }
            });
        },

        ajaxInfiniteScrollingMapData: function (data) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            
            var currentTemplate = document.getElementById('CollectionProductGrid');
            if (!currentTemplate) return;
            
            const currentProductListing = currentTemplate.querySelector('.productListing');
            const currentPagination = currentTemplate.querySelector('.pagination');
            const newTemplate = doc.getElementById('CollectionProductGrid');
            
            if (!newTemplate || !currentProductListing) return;
            
            const newProductListing = newTemplate.querySelector('.productListing');
            const newPagination = newTemplate.querySelector('.pagination');
            const newProductItem = newProductListing ? Array.from(newProductListing.querySelectorAll('.product')) : [];

            if (newProductItem.length > 0) {
                newProductItem.forEach(item => currentProductListing.appendChild(item));
                if (currentPagination && newPagination) {
                currentPagination.replaceWith(newPagination);
                }

                const totalStart = document.querySelector('[data-total-start]');
                if(totalStart) totalStart.textContent = '1';

                const halo = getHalo();
                if (window.compare && window.compare.show) {
                    const compareLink = document.querySelector('[data-compare-link]');
                    if (compareLink && halo.setLocalStorageProductForCompare) {
                        halo.setLocalStorageProductForCompare(compareLink);
                    }
                }

                if (window.wishlist && window.wishlist.show && halo.setLocalStorageProductForWishlist) {
                    halo.setLocalStorageProductForWishlist();
                }

                if (halo.checkNeedToConvertCurrency && halo.checkNeedToConvertCurrency()) {
                    const currencyEl = document.querySelector('#currencies .active');
                    const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                    if (currencyCode) {
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }
                }
            }
        }
    };
    
    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }
    
    // Attach all infinite scrolling functions to halo
    Object.assign(window.halo, infiniteScrolling);
    
    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            infiniteScrolling.initInfiniteScrolling();
        });
    } else {
        infiniteScrolling.initInfiniteScrolling();
    }
})();









